import p5 from "p5";
import { ServiceProvider } from ".";
import { registerMouseHandlers, registerTouchHandlers } from "../shared/mouseFunctions";
import { windowResized, displayDrawError } from "../shared/utils";
import { keyPressed, registerSpacebarListeners } from "./keyFunctions";

const s = (p) => {
    let provider;
    let drawErrorReported = false;

    p.setup = () => {
        try {
            provider = new ServiceProvider(p);
            provider.canvas = p.createCanvas(p.windowWidth, p.windowHeight - 7);
            provider.canvas.style('display', 'block');

            provider.init();

            registerSpacebarListeners(provider);
            registerMouseHandlers(p, provider);
            registerTouchHandlers(p, provider);
        } catch (e) {
            window.posthog?.captureException(e);
            throw e;
        }
    };

    p.draw = () => {
        try {
            // // Not sure if to keep. Doesn't work, but the menu is also fucking it up.
            // if (p.width != document.documentElement.clientWidth
            //     || p.height != document.documentElement.clientHeight
            //     || p.height != window.innerHeight
            // ) {
            //     windowResized(provider);
            // }

            p.background(provider.backgroundColor);

            if (provider.settings.showImage
                && provider.image
                && provider.image.loaded
            ) {
                p.push();
                p.translate(provider.view.posX, provider.view.posY);
                provider.image.display(p);
                p.pop();
            }

            provider.grid.display(p);

            p.push();
            p.translate(provider.view.posX, provider.view.posY);

            provider.elements.display(p);
            provider.tools.currentTool.display(p);

            p.pop();

            provider.tips.display();
            provider.grid.displayLegend(p);

            // Debug
            // p.fill(255);
            // p.stroke(0);
            // p.rect(10, p.height - 150, 200, 140);
            // p.fill(0);
            // p.textSize(15);
            // p.noStroke();
            // p.textAlign(p.LEFT, p.TOP);
            // Object.values(provider.debug).map((value, index) => {
            //     p.text(value, 20, p.height - 145 + index * 18);
            // });
        } catch (e) {
            if (!drawErrorReported) {
                drawErrorReported = true;
                window.posthog?.captureException(e);
            }
            displayDrawError(p);
        }
    };

    p.windowResized = () => {
        if (!provider?.loaded) return false;
        windowResized(provider);
    }

    p.keyPressed = (event) => {
        if (!provider?.loaded) return false;
        keyPressed(provider, event);
    }
};
let planSketch = new p5(s, 'p5canvas');

export { s, planSketch };
